import React from "react";
import "../css/error.css";

const ErrorPage = () => {
  return (
    <div>
      <h1>Page not found</h1>
    </div>
  );
};

export default ErrorPage;
